import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const PageHeader = ({ title, breadcrumb }) => {
  return (
    <section className="relative pt-32 pb-16 bg-gradient-to-br from-[#1a3a6e] to-[#0f2a55] overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#22b8db] blur-3xl" />
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-[#22b8db] blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 text-white">
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight">{title}</h1>
        <div className="mt-3 flex items-center gap-2 text-sm text-white/80">
          <Link to="/" className="hover:text-[#22b8db]">Home</Link>
          <ChevronRight className="w-4 h-4" />
          <span className="text-[#22b8db] font-semibold">{breadcrumb}</span>
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
